<div class="row" style="border-bottom: 1px solid #dee2e6">
    <div class="col">
        <h5 class="modal-title w-600 text-left p-1 m-0" id="myModalLabel">
            Lista de Registro de Auditoría de {{auditoria?.entidad}}
        </h5>
    </div>
</div>
<div class="row">
    <div class="col-12 table-responsive">
        <table mdbTableScroll scrollY="true" maxHeight="500" small="true" stickyHeader="true" class="table table-striped table-hover table-sm">
            <thead class="grey lighten-2">
                <tr>
                    <th *ngFor="let cabecera of cabecerasTabla" class="text-center">{{cabecera}}</th>
                </tr>
            </thead>
            <tbody *ngIf="listAuditoria?.length > 0">
                <tr mdbTableCol *ngFor="let auditoria of listAuditoria">
                    <td class="text-center">{{ auditoria.fecha | date: 'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ auditoria.fecha | date: 'HH:mm' }}</td>
                    <td class="text-center" *ngIf="cabecerasTabla.includes('SKU')">{{ auditoria.producto_sku }}</td>
                    <td class="text-center" style="width: 15%;">{{ 
                            isEventoAgregar(auditoria.evento_auditoria_codigo) ? 
                            auditoria.nombre_evento_auditoria : 
                            auditoria.nombrePropiedad
                        }}
                    </td>
                    <ng-container *ngIf="auditoria.datoAntiguo?.length > 0;else noDatoAntiguo">
                        <td class="text-center" style="width: 30%;">{{ auditoria.datoAntiguo }}</td>
                        <td class="text-center" style="width: 30%;">{{ auditoria.datoNuevo }}</td>
                    </ng-container>
                    <ng-template #noDatoAntiguo>
                        <td class="text-center" style="width: 60%;" colspan="2">{{ auditoria.datoNuevo }}</td>
                    </ng-template>
                    <td class="text-center">{{ auditoria.nombreUsuario }}</td>
                </tr>
                <!-- <ng-container *ngFor="let g of groupAuditoria">
                    <tr class="table-primary">
                        <td colspan="5" class="text-center font-weight-bold p-0">Fecha Registro: {{ g.fecha }}</td>
                    </tr>
                    <tr *ngFor="let auditoria of g.auditorias">
                        <td class="text-center">{{ auditoria.fecha | date: 'HH:mm' }}</td>
                        <td class="text-center" style="width: 15%;">{{ 
                                isEventoAgregar(auditoria.evento_auditoria_codigo) ? 
                                auditoria.nombre_evento_auditoria : 
                                auditoria.nombrePropiedad
                            }}
                        </td>
                        <ng-container *ngIf="auditoria.datoAntiguo?.length > 0;else noDatoAntiguo">
                            <td class="text-center" style="width: 30%;">{{ auditoria.datoAntiguo }}</td>
                            <td class="text-center" style="width: 30%;">{{ auditoria.datoNuevo }}</td>
                        </ng-container>
                        <ng-template #noDatoAntiguo>
                            <td class="text-center" style="width: 60%;" colspan="2">{{ auditoria.datoNuevo }}</td>
                        </ng-template>
                        <td class="text-center">{{ auditoria.nombreUsuario }}</td>
                    </tr>
                </ng-container> -->
            </tbody>
        </table>
        <mdb-card *ngIf="loading">
            <mdb-card-body>
              <mdb-card-title class="text-center">
                <h4>Cargando registros...</h4>
              </mdb-card-title>
            </mdb-card-body>
        </mdb-card>
        <mdb-card *ngIf="listAuditoria.length === 0 && !loading">
            <mdb-card-body>
              <mdb-card-title class="text-center">
                <h4>No existen registros de auditoria</h4>
              </mdb-card-title>
            </mdb-card-body>
        </mdb-card>
    </div>
</div>